import SimpleBar from 'simplebar';
import { isDesktop, preventCustomScrollPage } from '../../utils';
import {
  PIN_HEADER_EVENT,
  MOUSE_WHEEL_CUSTOM_EVENT,
  HEADER_UP, HEADER_DOWN,
  USER_INTERACTION_EVENTS,
} from '../../constants';

export default class FundamentalSubNavigation {
  constructor(el) {
    this.$el = $(el);

    this.text = {
      transform: 'transform',
      zIndex: 'z-index',
    };

    this.classes = {
      hidden: 'hidden',
      howToBuyActive: 'how-to-buy-active',
      trimDropdownActive: 'trim-dropdown-active',
      active: 'active',
      openTrimList: 'open-trim-list',
      pinSubNav: 'pin-sub-nav',
      showScrollHeader: 'always-show-scroll-header',
      hideScrollHeader: 'always-hide-scroll-header',
      wheelUp: 'wheel-up',
      wheelDown: 'wheel-down',
      overflowYAuto: 'overflow-y-auto',

    };

    this.elementClasses = {
      howToBuyBtn: '.js-how-to-buy-btn',
      subNavBtnList: '.js-sub-nav-btn-list',
      navTrimControl: '.js-nav-trim-control',
      navTrimDropdown: '.js-nav-trim-dropdown',
      subNavWrap: '.js-sub-nav-wrap',
      subNavControl: '.js-sub-nav-control',
      navTrimWrap: '.js-nav-trim-wrap',
      groupPinTop: '.js-group-pin-top',
      groupPinBottom: '.js-group-pin-bottom',

    };

    this.dom = {
      $subNav: this.$el.find('.js-sub-nav'),
      $subNavBtnList: this.$el.find(this.elementClasses.subNavBtnList),
      $howToBuyBtn: this.$el.find(this.elementClasses.howToBuyBtn),
      $navTrimControl: this.$el.find(this.elementClasses.navTrimControl),
      $navTrimDropdown: this.$el.find(this.elementClasses.navTrimDropdown),
      $subNavWrap: this.$el.find(this.elementClasses.subNavWrap),
      $subNavControl: this.$el.find(this.elementClasses.subNavControl),
      $navTrimWrap: this.$el.find(this.elementClasses.navTrimWrap),
      $navListItems: this.$el.find('.sub-nav-list-items'),
      $groupContentTop: this.$el.find('.js-group-content-top'),
      $groupContentTopInner: this.$el.find('.group-content-top-inner'),
      $groupContentBottom: this.$el.find('.js-group-content-bottom'),
      $groupContentBottomParent: this.$el.find('.js-group-content-bottom').parent(),
      $html: $('html'),
      $body: $('body'),
      $header: $('.header'),
      $footer: $('.footer'),
      $mainContent: $('.main-content'),
      $features: $('[data-module="Features"]'),
      $banner360: $('[data-module="ModTrimBannerHero"]'),

    };

    this.$tabSubNavItems = this.dom.$groupContentTop.find('.tab-sub-nav-item');

    this.prevInnerWidth = window.innerWidth;
    this.headerDirection = HEADER_DOWN;
    this.currentHeaderDirection = HEADER_DOWN;
    this.unPinHeader = false;
    this.currentUnPinHeader = false;
    this.customSpace = 0;
    this.customScrollTop = 0;
    this.positionFlag = 0;
    this.dontShowHeader = false;
    this.navIsPinned = false;

    this.groupTopUnPinAboveFooter = false;
    this.isGroupTopOnHeader = false;

    this.onResizeEvent = this.onResizeEvent.bind(this);
    this.resetMobileUpDesktop = false;
    this.simplebarList = [];
  }

  init() {
    this.dom.$footer.before(`<div class="html-mask-space h-24 xl:h-0 relative z-10"></div>`);
    this.$maskSpace = $('.html-mask-space');

    if (isDesktop()) {
      this.initScrollAreaOfTrimDropdown();
    } else {
      this.dom.$navListItems.removeClass(this.classes.overflowYAuto);
    }
  }

  addListeners() {
    this.dom.$howToBuyBtn.on('click', () => {
      this.toggleShowHideHowToBuyList();
    });

    this.dom.$navTrimControl.on('click', (e) => {
      e.preventDefault();
      this.setPositionOfYearTabListWithNameOfTrim();
      if (this.dom.$navTrimControl.hasClass(this.classes.trimDropdownActive)) {
        this.hideTrimDropdown();
      } else {
        this.showTrimDropdown();
      }
    });

    this.dom.$subNavControl.on('click', () => {
      if (!isDesktop()) {
        this.toggleSubNavMobile();
      }
    });

    // change height of dropdown when click tab sub nav on mobile
    this.$tabSubNavItems.on('click', (e) => {
      if (!isDesktop()) {
        const $target = $(e.currentTarget);
        const index = $target.index();
        setTimeout(() => {
          this.dom.$navTrimDropdown.css('height', this.dom.$navListItems.get(index).scrollHeight || '');
          this.dom.$navListItems.removeClass(this.classes.overflowYAuto);
        }, 100);
      } else {
        this.initScrollAreaOfTrimDropdown();
      }
    });

    $(document).on('click', (e) => {
      const $target = $(e.target);
      this.hideSubNavClickOutside($target);
      this.hideHowToBuyListClickOutside($target);
      this.hideTrimDropdownOutSide($target);
    });

    $(window).on('resize', this.onResizeEvent);

    window.addEventListener(MOUSE_WHEEL_CUSTOM_EVENT, (event) => {
      this.headerDirection = event.detail.wheel === 'up' ? HEADER_DOWN : HEADER_UP;
    });

    window.addEventListener(PIN_HEADER_EVENT, (event) => {
      this.unPinHeader = !event.detail.pinHeader;
    });

    window.addEventListener('wheel', (e) => {
      if (isDesktop() && !$(e.target).closest(`.${this.classes.openTrimList}`).length) {
        this.hideTrimDropdown();
      }
    });

    window.addEventListener('focusin', (e) => {
      const $target = $(e.target);
      if (!$target.closest(this.elementClasses.navTrimWrap).length) {
        this.hideTrimDropdown();
      }

      if (!$target.closest(this.elementClasses.subNavBtnList).length) {
        this.hideHowToBuyList();
      }
    });

    this.customScrollEvent();

    /* init move DOM Sub Nav to under header on mobile */
    $(window).on(USER_INTERACTION_EVENTS, () => {
      this.moveDomGroupTopAndBottomUnderHeaderMobile();
    });
  }

  moveDomGroupTopAndBottomUnderHeaderMobile() {
    if (!isDesktop() && !this.isGroupTopOnHeader) {
      this.isGroupTopOnHeader = true;
      this.dom.$header.after(this.dom.$groupContentTop);
      this.dom.$header.after(this.dom.$groupContentBottom);
    }
  }

  moveBackDomGroupTopAndBottomToInitialRoot() {
    if (isDesktop() && this.isGroupTopOnHeader) {
      this.isGroupTopOnHeader = false;
      $(this.elementClasses.groupPinTop).append(this.dom.$groupContentTop);
      $(this.elementClasses.groupPinBottom).append(this.dom.$groupContentBottom);
    }
  }

  /* event Scroll page */
  customScrollEvent() {
    window.scrollAgent.scrollEvent((args) => {
      const scrollY = parseFloat(args.scroll.y.toFixed(2));
      if (isDesktop() && this.positionFlag !== scrollY) {
        this.positionFlag = scrollY;
        this.customScrollTop = scrollY;
      }
    });
    $(window).on('scroll', () => {
      if (!isDesktop()) {
        this.customScrollTop = $(window).scrollTop();

        if (this.customScrollTop === 0) {
          this.dom.$body.removeClass(this.classes.showScrollHeader).removeClass(this.classes.hideScrollHeader);
          this.hideSubNav();
        }
      }
    });
  }

  /* Resize event */
  onResizeEvent() {
    if (window.innerWidth !== this.prevInnerWidth) {
      this.hideTrimDropdown();
      this.hideHowToBuyList();
      if (!isDesktop()) {
        this.hideSubNav();
      }

      this.prevInnerWidth = window.innerWidth;
    }
    this.setPositionOfYearTabListWithNameOfTrim();
    this.calculateSubNavDropdownScrollableHeight();

    // update position of group top and bottom DOM when resize window
    if (isDesktop()) {
      this.moveBackDomGroupTopAndBottomToInitialRoot();
    } else {
      this.moveDomGroupTopAndBottomUnderHeaderMobile();
    }
    clearTimeout(this.timerResize);
    this.timerResize = setTimeout(() => {
      if (isDesktop()) {
        this.resetUnpinGroupBottomAboveFooterMobile();
      } else {
        this.unpinGroupBottomAboveFooterMobile();
      }
    }, 100);

    if (!isDesktop()) {
      if (this.simplebarList.length) {
        this.resetScrollAreaOfTrimDropdown();
      }
      this.simplebarList = [];
    } else {
      this.initScrollAreaOfTrimDropdown();
    }
  }

  toggleShowHideHowToBuyList() {
    this.dom.$howToBuyBtn.toggleClass(this.classes.howToBuyActive);
    this.dom.$subNavBtnList.stop().slideToggle(300);
    if (this.dom.$howToBuyBtn.hasClass(this.classes.howToBuyActive)) {
      this.dom.$groupContentBottom.css(this.text.zIndex, 100);
    } else {
      this.dom.$groupContentBottom.css(this.text.zIndex, '');
    }
  }

  showTrimDropdown() {
    this.dom.$navTrimControl.addClass(this.classes.trimDropdownActive);
    this.dom.$navTrimWrap.addClass(this.classes.openTrimList);
    if (!isDesktop()) {
      this.dom.$navTrimDropdown.css('height', this.dom.$navTrimDropdown.get(0).scrollHeight);
    }
  }

  hideTrimDropdown() {
    this.dom.$navTrimControl.removeClass(this.classes.trimDropdownActive);
    this.dom.$navTrimWrap.removeClass(this.classes.openTrimList);
    this.dom.$navTrimDropdown.css('height', '');
    setTimeout(() => {
      this.dom.$navListItems.find('.simplebar-content-wrapper').scrollTop(0);
    }, 300);
  }

  hideTrimDropdownOutSide($target) {
    if (!$target.closest(this.elementClasses.navTrimWrap).length && !$target.closest(this.elementClasses.navTrimControl).length) {
      this.hideTrimDropdown();
    }
  }

  toggleSubNavMobile() {
    if (!this.dom.$subNavControl.hasClass(this.classes.active)) {
      this.dom.$subNavControl.addClass(this.classes.active);
      this.dom.$groupContentTop.addClass(this.classes.active);
      this.dom.$subNavWrap.stop().slideDown(300);
    } else {
      this.hideSubNav();
    }
    this.calculateSubNavDropdownScrollableHeight();

    // show hide scroll header on mobile when open subnav
    setTimeout(() => {
      if (!isDesktop()) {
        this.noToggleHeaderWhenOpenSubNavMobile();
      } else {
        this.dom.$body.removeClass(this.classes.showScrollHeader).removeClass(this.classes.hideScrollHeader);
      }
    }, 100);
  }

  hideSubNavClickOutside($target) {
    if (!$target.closest(this.elementClasses.subNavWrap).length && !isDesktop()
      && !$target.closest(this.elementClasses.subNavControl).length) {
      this.hideSubNav();
    }
  }

  hideSubNav() {
    this.dom.$subNavControl.removeClass(this.classes.active);
    this.dom.$groupContentTop.removeClass(this.classes.active);
    this.dom.$subNavWrap.slideUp(300);

    // remove always show hide scroll header when close subnav
    this.dom.$body.removeClass(this.classes.showScrollHeader).removeClass(this.classes.hideScrollHeader);
  }

  hideHowToBuyListClickOutside($target) {
    if (!$target.closest(this.elementClasses.subNavBtnList).length && !$target.closest(this.elementClasses.howToBuyBtn).length) {
      this.hideHowToBuyList();
    }
  }

  hideHowToBuyList() {
    this.dom.$howToBuyBtn.removeClass(this.classes.howToBuyActive);
    this.dom.$subNavBtnList.slideUp(300);
    this.dom.$groupContentBottom.css(this.text.zIndex, '');
  }

  /* ********************* */
  /* Layout SubNav inner Dropdown
  /* function Year Tab List Position When open Dropdown
  /* function animate Trim Heading Text When Scroll Down and Pin Header
  */

  setPositionOfYearTabListWithNameOfTrim() {
    const $tabList = this.dom.$navTrimDropdown.find('[role="tablist"]');
    const $trimName = this.dom.$navTrimControl.find('.text');
    const trimNameWidth = $trimName.length ? $trimName?.outerWidth() : 0;
    const trimNameOffsetLeft = $trimName.length ? $trimName?.position().left : 0;
    if (!isDesktop()) {
      $tabList.css('left', `${trimNameOffsetLeft + trimNameWidth}px`);
    } else {
      $tabList.css('left', '');
    }
  }

  calculateSubNavDropdownScrollableHeight() {
    const screenHeight = document.documentElement.clientHeight || window.innerHeight;
    const height = screenHeight - this.dom.$header.outerHeight() - this.dom.$groupContentBottom.outerHeight();
    if (!isDesktop()) {
      this.dom.$groupContentTopInner.css('max-height', height);
    } else {
      this.dom.$groupContentTopInner.css('max-height', '');
    }
  }

  noToggleHeaderWhenOpenSubNavMobile() {
    if (this.dom.$subNavControl.hasClass(this.classes.active)) {
      if (this.dom.$body.hasClass(this.classes.wheelUp)
        || (!this.dom.$body.hasClass(this.classes.wheelDown) && !this.dom.$body.hasClass(this.classes.wheelUp))) {
        this.dom.$body.addClass(this.classes.showScrollHeader);
      }
      if (this.dom.$body.hasClass(this.classes.wheelDown)) {
        this.dom.$body.addClass(this.classes.hideScrollHeader);
      }
    }
  }

  /* End Layout SubNav inner Dropdown */
  /* ********************* */

  /* ********************* */
  /* Pin action for each template: feature, trim, model */
  /* ********************* */

  unpinGroupBottomAboveFooterMobile() {
    const footerOffsetTop = this.dom.$footer.offset().top;
    const windowHeight = window.innerHeight;
    if (this.customScrollTop + windowHeight > footerOffsetTop) {
      if (!this.groupTopUnPinAboveFooter) {
        this.groupTopUnPinAboveFooter = true;
        this.dom.$groupContentBottom.css('position', 'relative');
        this.$maskSpace.append(this.dom.$groupContentBottom);
      }
    } else {
      this.resetUnpinGroupBottomAboveFooterMobile();
    }
  }

  resetUnpinGroupBottomAboveFooterMobile() {
    if (this.groupTopUnPinAboveFooter) {
      this.groupTopUnPinAboveFooter = false;
      this.dom.$groupContentBottom.css({ transform: '', transition: '', bottom: '', top: '', position: '' });
      this.dom.$groupContentBottomParent.append(this.dom.$groupContentBottom);
    }
  }

  /* End pin action for each template */
  /* ********************* */

  initScrollAreaOfTrimDropdown() {
    this.dom.$navListItems.each((_index, item) => {
      const $item = $(item);
      const contentHeight = $item.find('ul').get(0).scrollHeight;
      const $tooltip = $item.find('.js-tooltip');
      if (contentHeight > 442) {
        $item.addClass(this.classes.overflowYAuto);
        // add position top for tooltip

        $tooltip.each((_idx, tooltip) => {
          if (_idx + 1 > $tooltip.length - 2) {
            $(tooltip).addClass('align-top');
          }
        });
        // init simplebar
        if ($item.attr('data-simplebar') !== 'init') {
          const simplebar = new SimpleBar(item, {
            autoHide: false,
          });
          this.simplebarList.push(simplebar);
        }
      } else {
        $item.removeClass(this.classes.overflowYAuto);
        $tooltip.removeClass('align-top');
      }
      preventCustomScrollPage(item);
    });
  }

  resetScrollAreaOfTrimDropdown() {
    if (this.simplebarList.length) {
      this.dom.$navListItems.each((_index, item) => {
        const $content = $(item).find('.simplebar-content').find('ul');
        if ($content) {
          $(item).append($content);
          $(item).find('.simplebar-wrapper, .simplebar-track').remove();
        }
      });
    }
  }
}
